import {z} from 'zod'

import {CreateOrUpdateBlockKeyFactSmallDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'

import type {BlockKeyFactSmallInput, CreateOrUpdateBlockKeyFactSmallMutation} from '@sdox/api'

type UpdateKeyFactSmallValidatorSchema = z.infer<typeof updateKeyFactSmallValidatorSchema>

const updateKeyFactSmallValidatorSchema = z.object({
  data: z.array(
    z.object({
      // image is selected as XcMediaRef from MediaLibrary
      image: z.object({
        // md5 hashes are actually 16 bytes long, but if the hash algorithm changes
        //  we would have a very hard to find bug if we expect a hard 16 chars.
        fileHash: z.string().min(1),
      }),
      heading: z.string().min(1),
      description: z.string().min(1),
      callout: z.string().min(1),
    }).required(),
  ),
  meta: updateMetaSchema,
})

export const keyFactSmallConfig = createFormConfig<
  UpdateKeyFactSmallValidatorSchema,
  CreateOrUpdateBlockKeyFactSmallMutation,
  BlockKeyFactSmallInput[]
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockKeyFactSmallDocument,
  },
  fieldMapper: (fieldValues) => {
    if (!Array.isArray(fieldValues.data)) {
      throw new Error('field values must have a data array')
    }

    return fieldValues.data.map((item) => ({
      heading: item.heading,
      description: item.description,
      callout: item.callout,
      fileHash: item.image.fileHash,
    }))
  },
  validatorSchema: updateKeyFactSmallValidatorSchema,
  inputFields: [
    {
      label: 'Key Fact',
      inputType: 'array',
      required: true,
      description: '',
      fieldName: 'data',
      defaultValue: undefined,
      fields: [
        {
          label: 'Image',
          fieldName: 'image',
          inputType: 'image',
          defaultValue: '',
          required: true,
        },
        {
          label: 'Title',
          fieldName: 'heading',
          inputType: 'text',
          defaultValue: '',
          required: true,
        },
        {
          label: 'Text',
          fieldName: 'description',
          inputType: 'text',
          defaultValue: '',
          required: false,
        },
        {
          label: 'Callout',
          fieldName: 'callout',
          inputType: 'text',
          defaultValue: '',
          required: false,
        },
      ],
    },
  ],
})
